'use client';
import CustomCheckBox from '@/components/shared/custom-check-box/custom-check-box.component';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';
import Image from 'next/image';

const CheckBoxGroup = ({
    text,
    selected,
    checkBoxClicked,
    value,
    img,
}: {
    text: string;
    value: string;
    selected: boolean;
    checkBoxClicked: (text: string) => void;
    img?: string | undefined;
}) => {
    const { t, IS_RTL = true } = useTranslation();
    // to avoid calling makeClicked twice when clicking on the chechbox directly
    const customCheckBoxClicked = () => {
        return;
    };
    return (
        <button
            onClick={() => checkBoxClicked(value)}
            className={`bg-transparent w-full p-[14px] border border-gray-200 rounded-lg flex items-center justify-between cursor-pointer ${
                selected ? 'border-green-700 bg-green-50' : ''
            }`}
        >
            <div className="flex items-center gap-3">
                <CustomCheckBox
                    selected={selected}
                    checkBoxClicked={customCheckBoxClicked}
                />
                <div className="flex items-center gap-1.5">
                    {img && (
                        <Image
                            width={28}
                            height={28}
                            style={{
                                width: '28px',
                                marginRight: IS_RTL ? '' : '12px',
                                marginLeft: IS_RTL ? '12px' : '',
                            }}
                            src={img}
                            alt={text}
                        />
                    )}
                    <Typography className="text-gray-700 text-captionMedium md:text-body2Medium">
                        {t(text as unknown as TemplateStringsArray)}
                    </Typography>
                </div>
            </div>
        </button>
    );
};

export default CheckBoxGroup;
